import { render, staticRenderFns } from "./workRemarkForm.vue?vue&type=template&id=785361b0&scoped=true&"
import script from "./workRemarkForm.vue?vue&type=script&lang=js&"
export * from "./workRemarkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785361b0",
  null
  
)

export default component.exports